import { create as createNiceModal, useModal } from '@ebay/nice-modal-react'
import { Close as CloseIcon } from '@mui/icons-material'
import { Divider, Drawer, FormControlLabel, Radio } from '@mui/material'
// import Switch, { SwitchProps } from '@mui/material/Switch' MPV3-5810 - temporary disabled code - Nov 13th 2024
import { observer } from 'mobx-react-lite'
import { ReactElement, useCallback, useState, useEffect } from 'react'
import { I18n } from 'common'
import { useUiStateStore } from '../../../../../src/store/uiState/UiStateStore'
import { defaultTheme } from '../../../../../src/theme/index'
import { breakpoints } from '../../../../../src/theme/breakpoints'
import { zIndex } from '../../../../../src/theme/zIndex'
import { Button } from '../../../../../src/ui-components/forms/Button'
import styled from 'styled-components'
import { CondensedSettingsView } from './CondensedSettingsView'
import {
  MiscPreferencesKeys,
  useUserStore,
} from '../../../../../src/store/user/UserStore'
import { parseBoolean } from '../../../../../src/ui-components/util/CommonFunctions'
// import { IS_HD_INTERCHANGE_FLOW_ENABLED } from '../../../../../src/config/ConfigManager'
import { Translate2 } from 'common'
// import { styled as muiStyled } from '@mui/material/styles' MPV3-5810 - temporary disabled code - Nov 13th 2024
// import { CondensedSettingsView } from './components/CondensedSettingsView'
// import { MiscPreferencesKeys, useUserStore } from 'src/store/user/UserStore'
// import { parseBoolean } from 'src/ui-components/util/CommonFunctions'
// import { IS_HD_INTERCHANGE_FLOW_ENABLED } from 'src/config/ConfigManager' MPV3-5810 - temporary disabled code - Nov 13th 2024
// import { Translate2 } from 'src/i18n/translate2'

/* 
MPV3-5810 - temporary disabled code - Nov 13th 2024 
when enabled back please use /src/ui-components/util/IOSStyledSwitch.tsx instead

const IOSSwitch = muiStyled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 54,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(28px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
})) */

export const CondensedViewSettingsDrawer = createNiceModal(
  observer((): ReactElement => {
    const modal = useModal()
    const uiStore = useUiStateStore()
    const user = useUserStore()
    const { isCondensedView, setIsCondensedView } = uiStore

    const handleOnClose = useCallback(() => {
      modal.remove()
    }, [modal])

    const [selection, setSelection] = useState<boolean>(isCondensedView)
    const [isPartTypeEnabled, setIsPartTypeEnabled] = useState<boolean>(false)
    const [isManufacturerEnabled, setIsManufacturerEnabled] =
      useState<boolean>(false)

    useEffect(() => {
      setIsPartTypeEnabled(
        parseBoolean(
          user.miscPreferences[MiscPreferencesKeys.INTERCHANGE_PARTTYPES]
        )
      )
      setIsManufacturerEnabled(
        parseBoolean(
          user.miscPreferences[MiscPreferencesKeys.INTERCHANGE_MANUFACTURERS]
        )
      )
    }, [user.miscPreferences])

    const saveAttributeHandler = () => {
      user.updateMiscPreferences({
        [MiscPreferencesKeys.INTERCHANGE_PARTTYPES]: `${isPartTypeEnabled}`,
        [MiscPreferencesKeys.INTERCHANGE_MANUFACTURERS]: `${isManufacturerEnabled}`,
      })
    }

    return (
      <Drawer anchor="right" open={modal.visible} onClose={handleOnClose}>
        <Container>
          <TitleWrapper>
            <Title>
              <I18n name="searchSettings" />
            </Title>
            <StyledCloseIcon onClick={handleOnClose} />
          </TitleWrapper>
          <HorizontalDivider style={{ marginBottom: '32px' }} />
          <div style={{ marginLeft: '32px', marginRight: '32px' }}>
            <DescriptionText>
              <ResultsTableDensityWrapper>
                <I18n name="resultsTableDensity" />
              </ResultsTableDensityWrapper>
              <I18n name="howToViewSearchResults" />
            </DescriptionText>
            <CondensedSettingOption>
              <FormControlLabel
                value="end"
                control={
                  <Radio
                    sx={{
                      '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)':
                        {
                          color: !selection
                            ? defaultTheme.colors.black
                            : '#ADADAA',
                        },
                      '& .MuiSvgIcon-root + .MuiSvgIcon-root': {
                        color: defaultTheme.colors.primary,
                      },
                    }}
                  />
                }
                label={Translate2('defaultSetting')}
                checked={!selection}
                onChange={() => {
                  setSelection(false)
                }}
                sx={{
                  minWidth: '115px',
                  height: '24px',
                  fontSize: '16px',
                }}
              />

              <CondensedSettingsView isCondensed={false} />
            </CondensedSettingOption>
            <CondensedSettingOption>
              <FormControlLabel
                value="end"
                control={
                  <Radio
                    sx={{
                      '& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)':
                        {
                          color: selection
                            ? defaultTheme.colors.black
                            : '#ADADAA',
                        },
                      '& .MuiSvgIcon-root + .MuiSvgIcon-root': {
                        color: defaultTheme.colors.primary,
                      },
                    }}
                  />
                }
                label={Translate2('condensed')}
                checked={selection}
                onChange={() => {
                  setSelection(true)
                }}
                sx={{
                  minWidth: '115px',
                  height: '24px',
                  fontSize: '16px',
                }}
              />
              <CondensedSettingsView isCondensed={true} />
            </CondensedSettingOption>
            {/* 
            MPV3-5810 - temporary disabled code - Nov 13th 2024
            {IS_HD_INTERCHANGE_FLOW_ENABLED && (
              <>
                <HorizontalDivider
                  style={{ marginTop: '32px', marginBottom: '33px' }}
                />
                <InterchangeSearch>
                  <InterchangeSearchHeader>
                    <I18n name="interchangesearch" />
                  </InterchangeSearchHeader>
                  <InterchangeSearchContent>
                    <InterchangeSearchContentTitleContainer>
                      <InterchangeSearchContentTitle>
                        <I18n name="choosePartType" />
                      </InterchangeSearchContentTitle>
                      <IOSSwitch
                        sx={{ m: 1 }}
                        checked={isPartTypeEnabled}
                        onChange={() =>
                          setIsPartTypeEnabled(!isPartTypeEnabled)
                        }
                      />
                    </InterchangeSearchContentTitleContainer>
                    <InterchangeSearchDescription>
                      <I18n name="choosePartTypeDescription" />
                    </InterchangeSearchDescription>
                  </InterchangeSearchContent>
                  <InterchangeSearchContent>
                    <InterchangeSearchContentTitleContainer>
                      <InterchangeSearchContentTitle>
                        <I18n name="selectFromManufacturer" />
                      </InterchangeSearchContentTitle>
                      <IOSSwitch
                        sx={{ m: 1 }}
                        checked={isManufacturerEnabled}
                        onChange={() =>
                          setIsManufacturerEnabled(!isManufacturerEnabled)
                        }
                      />
                    </InterchangeSearchContentTitleContainer>
                    <InterchangeSearchDescription>
                      <I18n name="selectFromManufacturerDescription" />
                    </InterchangeSearchDescription>
                  </InterchangeSearchContent>
                </InterchangeSearch>
              </>
            )} */}
          </div>
          <FooterContainer>
            <HorizontalDivider />
            <ButtonsWrapper>
              <Button
                text="cancel"
                onClick={handleOnClose}
                variant="secondary"
                style={{ height: '48px', margin: 0, marginRight: '8px' }}
              />
              <Button
                text="apply"
                variant="primary"
                type="submit"
                onClick={() => {
                  setIsCondensedView(selection)
                  saveAttributeHandler()
                  handleOnClose()
                }}
                style={{ height: '48px', margin: 0 }}
              />
            </ButtonsWrapper>
          </FooterContainer>
        </Container>
      </Drawer>
    )
  })
)

const Container = styled.div`
  height: 100%;
  width: 533px;
  background-color: #ffffff;
  z-index: ${zIndex.modal};
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: ${breakpoints.mobileLarge}px) {
    width: 85vw;
    padding: 24px 16px 50px 16px;
  }
`
const Title = styled.span`
  font-family: Oswald, serif;
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  color: #050505;
  line-height: 48px;
`

const StyledCloseIcon = styled(CloseIcon)`
  cursor: pointer;
`

const DescriptionText = styled.span`
  font-family: Roboto, serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #050505;
  mix-blend-mode: normal;
  opacity: 0.9;
  padding: 0px, 32px, 0px, 32px;
`

const TitleWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 24px 32px;
`
const CondensedSettingOption = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: top;
  margin-top: 20px;
  flex-wrap: no-wrap;
  @media screen and (max-width: ${breakpoints.tablet}px) {
    flex-wrap: wrap;
  }
`

const ButtonsWrapper = styled.div`
  justify-content: end;
  align-items: center;
  display: flex;
  margin: 32px 32px 0px 0px;
`
const ResultsTableDensityWrapper = styled.div`
  width: 100%;
  font-size: 16px;
  font-family: Oswald, serif;
  font-style: normal;
  font-weight: 700;
  line-height: 23.71px;
`

/* 
MPV3-5810 - temporary disabled code - Nov 13th 2024
const InterchangeSearch = styled.div`
  display: flex;
  flex-direction: column;
`
const InterchangeSearchHeader = styled.div`
  font-size: 16px;
  font-family: Oswald, serif;
  font-weight: bold;
  margin-bottom: 16px;
  line-height: 23.71px;
`
const InterchangeSearchContent = styled.div`
  width: 100%;
`
const InterchangeSearchContentTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 12px;
  justify-content: space-between;
  align-items: center;
`
const InterchangeSearchContentTitle = styled.div`
  font-size: 16px;
  line-height: 24px;
  font-family: Roboto, serif;
  font-weight: bold;
`
const InterchangeSearchDescription = styled.p`
  font-size: 14px;
  line-height: 24px;
  font-family: Roboto, serif;
  font-weight: 400;
  padding-bottom: 12px;
` */

const FooterContainer = styled.div`
  margin-top: auto;
  height: 112px;
`
const HorizontalDivider = styled(Divider)`
  background-color: ${defaultTheme.colors.black};
  width: 100%;
  height: 1px;
`
